import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";

interface NPSQuestionProps {
  answer: any;
  onChange: any;
  question: any;
  error: string;
}

class NPSQuestion extends React.Component<NPSQuestionProps, {}> {
  state = {
    answer: this.props.answer
  };

  arr(n: any) {
    const arr = [];

    for (let i = 0; i <= n; i++) {
      arr.push(i);
    }

    return arr;
  }

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const val = Number(e.currentTarget.value);
    this.props.onChange(this.props.question, val);
    this.setState({ answer: val });
  };

  renderInputs() {
    const nameAttr = "velaro-answer-" + this.props.question.QuestionID;

    return this.arr(10).map((i: any) => {
      return (
        <td key={i}>
          <input
            type="radio"
            name={nameAttr}
            onChange={this.onChange}
            value={i}
            checked={this.state.answer === i}
            aria-checked={this.state.answer === i}
            aria-label={i}
          />
        </td>
      );
    });
  }

  renderLabels() {
    return this.arr(10).map(i => <td key={i}>{i}</td>);
  }

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <table className="velaro-nps-table">
          <tbody>
            <tr>{this.renderInputs()}</tr>
            <tr>{this.renderLabels()}</tr>
            <tr>
              <td colSpan={5} style={{ textAlign: "left" }}>
                Not likely
              </td>
              <td colSpan={6} style={{ textAlign: "right" }}>
                Very likely
              </td>
            </tr>
          </tbody>
        </table>
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default NPSQuestion;
